<div class="modal-header" >

  <mat-icon class="btnInfo"  (click)="closePopup()">{{getIcone()}}</mat-icon>

  <div class="header-actions">
    <mat-icon class="btnCopy" *ngIf="isMensagemErro() && temLinhasSuficientes()" (click)="copiarConteudo()" matTooltip="Copiar conteúdo">content_copy</mat-icon>
    <mat-icon class="btnCancelTest" *ngIf="data.type != 'warning'"  (click)="closePopup()" matTooltip="Fechar">close</mat-icon>
  </div>

</div>
<div class="modal-body" #mensagensContainer>
    <h2 class="title">{{data.title}}</h2>  
      <div *ngIf="data.subtitle?.trim()" fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%">
        <div>
         <p class="message">{{data.subtitle}}</p>  
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="11%">
        <div class="optional">
            <div [innerHTML]="htmlStr"></div>
        </div>
      </div>
      
    <p class="optional"></p>
</div>
<div class="modal-footer">
    <button class="cancel" *ngIf="confirm"  (click)="notConfirm()" >Não</button>
    <button  id="btnTipoDoc"  (click)="Confirm()" class="confirm" >{{textButton}}</button>
</div>
